// /ops/backups — копии базы и проверки восстановления (FR-048). Право — ops.backups.read:
// сопровождение. «Только неудачные» и период — в адресе страницы (?result=failed&from=&to=).
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { BackupsPage } from '../../features/ops/BackupsPage.tsx';
import { parseBackupsSearch } from '../../features/ops/backups-search.ts';
import type { BackupsSearch } from '../../features/ops/backups-search.ts';
import { requireSection } from '../../shell/permissions.ts';

export const Route = createFileRoute('/_app/ops/backups')({
  validateSearch: parseBackupsSearch,
  beforeLoad: requireSection('backups'),
  staticData: { crumb: 'Копии' },
  component: BackupsRoute,
});

function BackupsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: BackupsSearch) => void navigate({ to: '/ops/backups', search: next, replace: true }),
    [navigate],
  );
  return <BackupsPage search={search} onSearchChange={onSearchChange} />;
}
